var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import keycode from 'keycode';
import { RadioButtonChecked, RadioButtonUnchecked } from '../icon';

var RadioButton = function (_React$Component) {
  _inherits(RadioButton, _React$Component);

  function RadioButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RadioButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      kbPressed: false
    }, _this.setKbPressed = function (e) {
      if (e.which === keycode('space')) {
        e.preventDefault();
        if (_this.props.selectedValue !== e.target.value) {
          _this.props.onChange(e.target.value);
        }
      }
      if (!_this.state.kbPressed) {
        _this.setState({ kbPressed: e.shiftKey ? 'shift' : true });
      }
    }, _this.resetKbPressed = function () {
      _this.setState({ kbPressed: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RadioButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // state handling & event handlers are necessary to mimic
      // native radio behaviour, which requires differentiating between
      // focus by keyboard and focus by mouse/touch interaction.
      var _props = this.props,
          name = _props.name,
          selectedValue = _props.selectedValue,
          items = _props.items,
          onChange = _props.onChange;
      var kbPressed = this.state.kbPressed;

      var shouldFocus = kbPressed && items.indexOf(selectedValue) < 0;
      var focusIndex = kbPressed === 'shift' ? items.length - 1 : 0;
      return React.createElement(
        'div',
        { className: classNames('mdc-RadioButton', { 'mdc-RadioButton--keyboard': kbPressed }),
          onKeyUp: this.setKbPressed,
          onClick: this.resetKbPressed,
          onBlur: this.resetKbPressed
        },
        items.map(function (item, index) {
          var checked = item.toLowerCase() === selectedValue.toLowerCase();
          return React.createElement(
            'label',
            { key: index,
              className: classNames('mdc-RadioButton-item', { 'mdc-RadioButton-item--keyboard': index === focusIndex && shouldFocus })
            },
            React.createElement('input', {
              checked: checked,
              className: 'mdc-RadioButton-input',
              name: name,
              onChange: onChange.bind(_this2, item),
              type: 'radio',
              value: item
            }),
            React.createElement(
              'div',
              { className: 'mdc-RadioButton-icon' },
              checked ? React.createElement(RadioButtonChecked, null) : React.createElement(RadioButtonUnchecked, null)
            ),
            React.createElement(
              'span',
              { className: 'mdc-RadioButton-label' },
              item
            )
          );
        })
      );
    }
  }]);

  return RadioButton;
}(React.Component);

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  selectedValue: PropTypes.string,
  items: PropTypes.array,
  onChange: PropTypes.func.isRequired
};

RadioButton.defaultProps = {
  selectedValue: 'two',
  items: ['one', 'two', 'three']
};

export default RadioButton;


//////////////////
// WEBPACK FOOTER
// ../es/js/radiobutton/index.js
// module id = 291
// module chunks = 0